import { useShopI18n } from '../../i18n'
import type { CheckoutCartSnapshotItem } from '../types'

type Props = {
  items: CheckoutCartSnapshotItem[]
  subtotal: number
  total: number
  formatCurrency: (value: number) => string
  disabled: boolean
  onContinue: () => void
}

export const CartReviewStep = ({
  items,
  subtotal,
  total,
  formatCurrency,
  disabled,
  onContinue,
}: Props) => {
  const { t } = useShopI18n()

  return (
    <section className="space-y-4 rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
      <header>
        <h2 className="text-lg font-semibold text-slate-900">{t('checkout.cartReview.title')}</h2>
        <p className="mt-1 text-sm text-slate-600">{t('checkout.cartReview.description')}</p>
      </header>

      <ul className="space-y-2">
        {items.map((item) => (
          <li key={item.itemId} className="flex items-center justify-between rounded-lg border border-slate-100 px-3 py-2">
            <div className="min-w-0">
              <p className="truncate text-sm font-medium text-slate-900">{item.productName}</p>
              <p className="text-xs text-slate-600">x{item.quantity}</p>
            </div>
            <p className="text-sm font-semibold text-slate-900">{formatCurrency(item.lineTotal)}</p>
          </li>
        ))}
      </ul>

      <div className="space-y-1 rounded-lg border border-slate-100 bg-slate-50 p-3 text-sm">
        <div className="flex items-center justify-between text-slate-700">
          <span>{t('checkout.review.subtotal')}</span>
          <span>{formatCurrency(subtotal)}</span>
        </div>
        <div className="flex items-center justify-between font-semibold text-slate-900">
          <span>{t('checkout.review.total')}</span>
          <span>{formatCurrency(total)}</span>
        </div>
      </div>

      <div className="flex justify-end">
        <button
          type="button"
          className="rounded-lg bg-slate-900 px-4 py-2 text-sm font-semibold text-white transition hover:bg-slate-800 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-slate-500 disabled:cursor-not-allowed disabled:opacity-50"
          disabled={disabled}
          onClick={onContinue}
        >
          {t('checkout.cta.continueCheckout')}
        </button>
      </div>
    </section>
  )
}
